/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} RequiredInputs */

const en_required = /** @type {(inputs: RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Required`)
};

const fr_required = /** @type {(inputs: RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Requis`)
};

const de_required = /** @type {(inputs: RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erforderlich`)
};

const it_required = /** @type {(inputs: RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Necessario`)
};

const ru_required = /** @type {(inputs: RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Необходимый`)
};

const es_required = /** @type {(inputs: RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Requerido`)
};

const zh_cn2_required = /** @type {(inputs: RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`必需的`)
};

const ja_required = /** @type {(inputs: RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`必須`)
};

const hi_required = /** @type {(inputs: RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आवश्यक`)
};

const pt_pt2_required = /** @type {(inputs: RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obrigatório`)
};

/**
* | output |
* | --- |
* | "Required" |
*
* @param {RequiredInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const required = /** @type {((inputs?: RequiredInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<RequiredInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_required(inputs)
	if (locale === "de") return de_required(inputs)
	if (locale === "it") return it_required(inputs)
	if (locale === "ru") return ru_required(inputs)
	if (locale === "es") return es_required(inputs)
	if (locale === "zh-CN") return zh_cn2_required(inputs)
	if (locale === "ja") return ja_required(inputs)
	if (locale === "hi") return hi_required(inputs)
	if (locale === "pt-PT") return pt_pt2_required(inputs)
	return en_required(inputs)
});